const TIPO_DOCUMENTO = {
    1: { id: 1, categoria: 'aviso', descricao: 'AGO' },
    2: { id: 2, categoria: 'aviso', descricao: 'AGO/E' },
    3: { id: 3, categoria: 'aviso', descricao: 'AGE' },
    4: { id: 4, categoria: 'sistema', descricao: 'Informe Mensal' },
    5: { id: 5, categoria: 'financeiro', descricao: 'Informe Trimestral' },
    6: { id: 6, categoria: 'financeiro', descricao: 'Informe Anual' },
    7: { id: 7, categoria: 'documento', descricao: 'Relatório do Representante de Cotistas' },
    8: { id: 8, categoria: 'financeiro', descricao: 'Informe Semestral - DFC e Relatório do Administrador' },
    9: { id: 9, categoria: 'financeiro', descricao: 'Relatório Gerencial' },
    10: { id: 10, categoria: 'promocional', descricao: 'Press - Release' },
    11: { id: 11, categoria: 'financeiro', descricao: 'Relatório Anual' },
    12: { id: 12, categoria: 'outros', descricao: 'Outros Relatórios' },
    13: { id: 13, categoria: 'promocional', descricao: 'Pospecto' },
    14: { id: 14, categoria: 'aviso', descricao: 'Anúncio de Início' },
    15: { id: 15, categoria: 'aviso', descricao: 'Aviso ao Mercado' },
    16: { id: 16, categoria: 'aviso', descricao: 'Anúncio de Encerramento' },
    17: { id: 17, categoria: 'aviso', descricao: 'Restritos - ICVM 476' },
    18: { id: 18, categoria: 'aviso', descricao: 'Aviso de Modificação de Oferta' },
    19: { id: 19, categoria: 'aviso', descricao: 'Outros Documentos' },
    26: { id: 26, categoria: 'promocional', descricao: 'Perfil do Fundo' },
    27: { id: 27, categoria: 'financeiro', descricao: 'Rentabilidade' },
    29: { id: 29, categoria: 'documento', descricao: 'Outros Documentos' },
    30: { id: 30, categoria: 'financeiro', descricao: 'Demonstração Financeiro' },
    31: { id: 31, categoria: 'documento', descricao: 'Instrumento Particular de Constituição/Encerramento do Fundo' },
    32: { id: 32, categoria: 'documento', descricao: 'Instrumento Particular de Alteração do Regulamento' },
    33: { id: 33, categoria: 'documento', descricao: 'Relação das Demandas Judiciais ou Extrajudiciais' },
    34: { id: 34, categoria: 'aviso', descricao: 'Edital de Oferta Pública de Aquisição de Cotas' },
    37: { id: 37, categoria: 'documento', descricao: 'Manifestação do Administrador / Gestor' },
    40: { id: 40, categoria: 'financeiro', descricao: 'Informe Mensal Estruturado' },
    41: { id: 41, categoria: 'financeiro', descricao: 'Rendimentos e Amortizações' },
    45: { id: 45, categoria: 'financeiro', descricao: 'Informe Trimestral Estruturado' },
    46: { id: 46, categoria: 'documento', descricao: 'Instrumento Particular de Emissão de Cotas' },
    47: { id: 47, categoria: 'financeiro', descricao: 'Informe Anual Estruturado' },
    49: { id: 49, categoria: 'aviso', descricao: 'Outros Comunicados Não Considerados Fatos Relevantes ' },
    50: { id: 50, categoria: 'aviso', descricao: 'Esclarecimentos de Consulta B3 / CVM' },
    51: { id: 51, categoria: 'financeiro', descricao: 'Demonstração Financeira de Encerramento' },
    52: { id: 52, categoria: 'financeiro', descricao: 'Relatório Anual' },
    53: { id: 53, categoria: 'promocional', descricao: 'Material de Divulgação' },
    63: { id: 63, categoria: 'financeiro', descricao: 'Composição da Carteira (CDA)' },
    64: { id: 64, categoria: 'sistema', descricao: 'Informe Diário' },
    65: { id: 65, categoria: 'sistema', descricao: 'Balancete' },
    68: { id: 68, categoria: 'sistema', descricao: 'Relatório de Agência de Rating' },
    90: { id: 90, categoria: 'financeiro', descricao: 'Anexo 39-V (art. 10 §1º, Inciso I da ICVM 472)' },
    91: { id: 91, categoria: 'financeiro', descricao: 'Demonstrações Financeiras de Devedores ou Coobrigados' },
    98: { id: 98, categoria: 'financeiro', descricao: 'Formulário de Subscrição de Cotas (Estruturado)' },
    100: { id: 100, categoria: 'sistema', descricao: 'Formulário de Liberação para Negociação das Cotas' },
    101: { id: 101, categoria: 'promocional', descricao: 'Perfil do Fundo (Estruturado)' },
    103: { id: 103, categoria: 'sistema', descricao: 'Formulário de Liberação para Negociação das Cotas' },
    131: { id: 131, categoria: 'documento', descricao: 'Registro CVM' },
    139: { id: 139, categoria: 'promocional', descricao: 'Lâmina de Oferta de FIDC' },
    140: { id: 140, categoria: 'promocional', descricao: 'Lâmina de Oferta de Fundos Fechados' },
    144: { id: 144, categoria: 'financeiro', descricao: 'Demonstrações Financeiras - Substituição de Administrador' },
    145: { id: 145, categoria: 'financeiro', descricao: 'Demonstrações Financeiras - Fusão, cisão e Incorporação' },
    146: { id: 146, categoria: 'financeiro', descricao: 'Demonstrações Financeiras - Encerramento de Atividade' },
    155: { id: 155, categoria: 'financeiro', descricao: 'Proventos em dinheiro' }
};
module.exports = TIPO_DOCUMENTO;

// <select id="categoriaDocumento" name="idCategoriaDocumento" tabindex="-1" title="" style="display: none;">
// 									<option value="0">Todos</option>
// 									<option value="25">Acordo de Acionista</option>
// 									<option value="19">Aditamento de Termo de Securitização</option>
// 									<option value="45">Aditamentos</option>
// 									<option value="2">Assembleia</option>
// 									<option value="46">Assembleia especial de investidores</option>
// 									<option value="37">Ata da Reunião do Conselho de Administração</option>
// 									<option value="11">Atos de Deliberação do Administrador</option>
// 									<option value="18">Averbação ou Registro do Termo de Securitização</option>
// 									<option value="4">Aviso aos Cotistas</option>
// 									<option value="14">Aviso aos Cotistas - Estruturado</option>
// 									<option value="20">Aviso aos Investidores</option>
// 									<option value="26">Comunicação de alteração do auditor independente</option>
// 									<option value="3">Comunicado ao Mercado</option>
// 									<option value="27">Dados Econômico Financeiros </option>
// 									<option value="16">Documentos de Oferta de Distribuição Pública</option>
// 									<option value="44">Escritura/Instrumento de Emissão</option>
// 									<option value="28">Estatuto Social</option>
// 									<option value="29">Falência</option>
// 									<option value="1">Fato Relevante</option>
// 									<option value="39">Formulário Cadastral</option>
// 									<option value="30">Formulário de Referência</option>
// 									<option value="42">Informações da SPE subsidiária integral - exclusivo para S2</option>
// 									<option value="21">Informações para Registro de Oferta de CRA</option>
// 									<option value="22">Informações para Registro de Oferta de CRI</option>
// 									<option value="23">Informações para Registro Provisório de Oferta de CRI</option>
// 									<option value="31">Informe Mensal de Outros Títulos de Securitização</option>
// 									<option value="32">Informe Trimestral</option>
// 									<option value="6">Informes Periódicos</option>
// 									<option value="41">Instrumento de Emissão e aditamentos</option>
// 									<option value="13">Laudo de Avaliação (Conclusão de Negócio)</option>
// 									<option value="24">Listagem e  Admissão à  Negociação  de Cotas</option>
// 									<option value="12">Oferta Pública de Aquisição de Cotas</option>
// 									<option value="8">Oferta Pública de Distribuição de Cotas</option>
// 									<option value="43">Outras Demonstrações Financeiras </option>
// 									<option value="10">Outras Informações</option>
// 									<option value="40">Outros Títulos de Securitização</option>
// 									<option value="33">Política de Negociação de Valores Mobiliários</option>
// 									<option value="9">Políticas de Governança Corporativa</option>
// 									<option value="34">Recuperação Extrajudicial</option>
// 									<option value="35">Recuperação Judicial</option>
// 									<option value="5">Regulamento</option>
// 									<option value="15">Regulamento de Emissores B3</option>
// 									<option value="36">Relatório de agência classificadora de risco</option>
// 									<option value="7">Relatórios</option>
// 									<option value="17">Termo de Securitização</option>
// 									<option value="38">Valores mobiliários detidos </option>
// 									</select>

// 3 ETF
// 4 ETF RF
// 2 FIDC
// 10 FIP
// 1 FUNDO IMOBILIARIO
// 7 FUNDO SETORIAL
